<div class="panel animate__animated animate__fadeIn border">
    <div class="panel-heading flex-wrap gap-2">
        <h4 class="panel-title d-flex align-items-center flex-wrap gap-2 min-w-0">
            <span class="badge bg-secondary" [attr.aria-label]="'Paso ' + flow.stepSequence">{{ flow.stepSequence }}</span>
            <span class="text-truncate" [title]="stepTitle()">{{ stepTitle() }}</span>
            @if (flow.isActive === false) {
                <span class="badge rounded-pill bg-secondary" title="No entra al flujo de las solicitudes hasta activarlo">
                    Inactivo
                </span>
            }
            @if (isTerminalStep()) {
                <span class="badge rounded-pill bg-success" title="Último paso: la solicitud termina aquí">
                    <i class="fas fa-flag-checkered me-1" aria-hidden="true"></i>
                    Final
                </span>
            }
            @if (!isTerminalStep()) {
                @if (flow.allowsToken) {
                    <span class="badge rounded-pill bg-primary"
                        role="listitem"
                        title="Enlace público por correo">
                        <i class="fas fa-link" aria-hidden="true"></i>
                        Enlace
                    </span>
                }
                @if (flow.contentReviewRole) {
                    <span class="badge rounded-pill bg-info"
                        role="listitem"
                        [title]="'Rol revisor: ' + roleLabel(flow.contentReviewRole)">
                        <i class="fas fa-images" aria-hidden="true"></i>
                        Revisor
                    </span>
                }
                @if (flow.requiresDocument) {
                    <span class="badge rounded-pill bg-warning text-dark"
                        role="listitem"
                        [title]="'Exige documento: ' + (flow.documentType?.name || documentTypeNameBySlug(flow.documentTypeSlug))">
                        <i class="fas fa-file-signature" aria-hidden="true"></i>
                        {{ flow.documentType?.name || documentTypeNameBySlug(flow.documentTypeSlug) }}
                    </span>
                }
                @if (flow.isExtraordinaryActive()) {
                    <span class="badge rounded-pill bg-warning text-dark"
                        role="listitem"
                        [title]="'Habilitación extraordinaria: ' + roleLabel(flow.alternateRole) + ' hasta ' + flow.alternateRoleUntil">
                        <i class="fas fa-user-clock" aria-hidden="true"></i>
                        Habilitado
                    </span>
                }
            }
            @if (flow.notifyRole && flow.requiredRole) {
                <span class="badge rounded-pill bg-success"
                    role="listitem"
                    [title]="isTerminalStep() ? 'Avisa al completar' : 'Notifica al rol al entrar al paso'">
                    <i class="fas fa-bell" aria-hidden="true"></i>
                    Notificar
                </span>
            }
        </h4>
        @if (!isFixedFinal()) {
            <div class="panel-heading-btn">
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn btn-white" (click)="moveUp.emit()"
                        [disabled]="index === 0" title="Mover Arriba">
                        <i class="fas fa-arrow-up"></i>
                    </button>
                    <button type="button" class="btn btn-white" (click)="moveDown.emit()"
                        [disabled]="isLastStep() || isNextFixedFinal()" title="Mover Abajo">
                        <i class="fas fa-arrow-down"></i>
                    </button>
                    <button type="button" class="btn btn-outline-danger" (click)="remove.emit()"
                        title="Eliminar Paso">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
            </div>
        }
    </div>

    <div class="panel-body">
        @if (!isTerminalStep()) {
            <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" [id]="'step-active-' + index"
                    [(ngModel)]="flow.isActive"
                    (ngModelChange)="emitChanged()">
                <label class="form-check-label" [for]="'step-active-' + index">
                    Activo en el flujo
                </label>
                <span class="small text-muted d-block">
                    Un paso inactivo queda guardado y no se replica a las solicitudes. Al activarlo, pasa a formar parte del recorrido.
                </span>
            </div>
            <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" [id]="'step-session-' + index"
                    [(ngModel)]="flow.requiresSession"
                    (ngModelChange)="emitChanged()">
                <label class="form-check-label" [for]="'step-session-' + index">
                    Requiere sesión
                </label>
                <span class="small text-muted d-block">
                    Este paso se decide en la reunión. La secretaría no lo cierra sola mientras haya una sesión enlazada abierta.
                </span>
            </div>
        }
        <div class="d-flex align-items-start justify-content-between gap-3 mb-3 flex-wrap">
            <div class="min-w-0">
                @if (isTerminalStep()) {
                    <span class="d-block fw-semibold">Cierre del flujo</span>
                    <span class="small text-muted">La solicitud se da por finalizada.</span>
                } @else {
                    <span class="d-block fw-semibold">Paso</span>
                    <span class="small text-muted">Estado, rol y notificación.</span>
                }
            </div>
            @if (!isTerminalStep()) {
            <div class="d-flex align-items-start gap-3 ms-auto">
                <label class="mb-0 text-end min-w-0" [for]="'token-' + index">
                    <span class="d-block fw-semibold">Enlace público por correo</span>
                    <span class="small text-muted">
                        @if (flow.allowsToken) {
                            Manda <code>/confirm-request</code>.
                        } @else {
                            El ID de acto se emite igual si el paso se cierra en la app.
                        }
                    </span>
                </label>
                <div class="form-check form-switch mb-0 flex-shrink-0 pt-1">
                    <input class="form-check-input" type="checkbox" role="switch"
                        [id]="'token-' + index"
                        [(ngModel)]="flow.allowsToken"
                        (ngModelChange)="onAllowsTokenChange()">
                </div>
            </div>
            }
        </div>

        <div class="row g-3 align-items-stretch">
            <div class="d-flex flex-column"
                [class.col-12]="isTerminalStep() || !flow.allowsToken"
                [class.col-lg-6]="!isTerminalStep() && flow.allowsToken">
                <div class="border rounded p-3 flex-grow-1">
                    <div class="row g-3">
                        <div [class.col-md-6]="isTerminalStep() || !flow.allowsToken" [class.col-12]="!isTerminalStep() && flow.allowsToken">
                            <label class="form-label mb-0" [for]="'status-' + index">Estado</label>
                            <ng-select class="mt-1"
                                [items]="statusesForSelect()"
                                bindLabel="name"
                                bindValue="uuid"
                                placeholder="Seleccionar estado"
                                [(ngModel)]="flow.statusUuid"
                                (ngModelChange)="onFlowStatusChange($event)"
                                [clearable]="false"
                                [disabled]="isFixedFinal()"
                                [labelForId]="'status-' + index"
                                appendTo="body">
                            </ng-select>
                            @if (isFixedFinal()) {
                                <div class="form-text">Cierre fijo: Aprobada (APPROVED). No se puede cambiar ni mover.</div>
                            }
                        </div>

                        @if (!isTerminalStep()) {
                        <div [class.col-md-6]="!flow.allowsToken" [class.col-12]="flow.allowsToken">
                            <label class="form-label mb-0" [for]="'role-' + index">Roles requeridos</label>
                            <ng-select class="mt-1" [id]="'role-' + index"
                                [items]="availableRoles"
                                bindLabel="displayName"
                                bindValue="slug"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Cualquier usuario autorizado"
                                [(ngModel)]="flow.requiredRoles"
                                (ngModelChange)="onRequiredRolesChange()">
                            </ng-select>
                            <span class="small text-muted d-block mt-1">
                                Uno o más roles pueden actuar en este paso (ej. ministro de fe, tesorero).
                            </span>
                        </div>

                        <div [class.col-md-6]="!flow.allowsToken" [class.col-12]="flow.allowsToken">
                            <label class="form-label mb-0" [for]="'alt-role-' + index">Habilitación extraordinaria</label>
                            <select class="form-select mt-1" [id]="'alt-role-' + index"
                                [(ngModel)]="flow.alternateRole"
                                (ngModelChange)="onExtraordinaryRoleChange()"
                                [disabled]="!flow.requiredRoles?.length">
                                <option [ngValue]="null">Sin habilitación</option>
                                @for (role of alternateRolesFor(); track (role.slug || role.name)) {
                                    <option [ngValue]="role.slug || role.name">{{ role.displayName || role.description || role.name }}</option>
                                }
                            </select>
                            <span class="small text-muted d-block mt-1">
                                Rol que puede aprobar este paso de forma temporal (vacaciones, cobertura).
                            </span>
                        </div>

                        @if (flow.alternateRole) {
                            <div [class.col-md-6]="!flow.allowsToken" [class.col-12]="flow.allowsToken">
                                <label class="form-label mb-0" [for]="'alt-until-' + index">Válida hasta</label>
                                <input class="form-control mt-1" type="date" [id]="'alt-until-' + index"
                                    [(ngModel)]="flow.alternateRoleUntil"
                                    [min]="minExtraordinaryDate()"
                                    (ngModelChange)="emitChanged()">
                                <div class="d-flex flex-wrap gap-2 mt-2">
                                    <button type="button" class="btn btn-outline-secondary btn-xs" (click)="setExtraordinaryDays(7)">7 días</button>
                                    <button type="button" class="btn btn-outline-secondary btn-xs" (click)="setExtraordinaryDays(15)">15 días</button>
                                    <button type="button" class="btn btn-outline-secondary btn-xs" (click)="setExtraordinaryDays(30)">1 mes</button>
                                </div>
                                <span class="small text-muted d-block mt-1">
                                    Al vencer, solo el rol requerido puede aprobar. Por defecto 1 mes.
                                </span>
                            </div>
                        }

                        <div [class.col-md-6]="!flow.allowsToken" [class.col-12]="flow.allowsToken">
                            <label class="form-label mb-0" [for]="'reviewer-' + index">Rol revisor</label>
                            <select class="form-select mt-1" [id]="'reviewer-' + index"
                                [(ngModel)]="flow.contentReviewRole"
                                (ngModelChange)="onContentReviewRoleChange()">
                                <option [ngValue]="null">Sin rol revisor</option>
                                @for (role of availableRoles; track (role.slug || role.name)) {
                                    <option [ngValue]="role.slug || role.name">{{ role.displayName || role.description || role.name }}</option>
                                }
                            </select>
                            <span class="small text-muted d-block mt-1">
                                <strong>Revisor intermedio</strong> (pasos previos con rol revisor): solo
                                <strong>Observar</strong> evidencias (vuelven a <code>PENDING</code> con
                                comentario para re-subir).
                                El <strong>último paso</strong> con rol revisor puede
                                <strong>aprobar o no</strong> y también <strong>Observar</strong>.
                                Negligencia y deducible del siniestro quedan gobernados por los permisos
                                del paso BPM (típicamente el rol requerido / revisor final), no por el
                                revisor intermedio.
                            </span>
                            @if (flow.contentReviewRole) {
                                <label class="form-label mb-0 mt-3" [for]="'resubmit-' + index">Al subsanar, ir a</label>
                                <select class="form-select mt-1" [id]="'resubmit-' + index"
                                    [(ngModel)]="flow.resubmitToStatusSlug"
                                    (ngModelChange)="emitChanged()">
                                    <option [ngValue]="null">Seleccionar estado</option>
                                    @for (s of flows; track s.stepSequence) {
                                        @if (s.statusSlug) {
                                            <option [ngValue]="s.statusSlug">{{ s.status?.name || s.statusSlug }}</option>
                                        }
                                    }
                                </select>
                                <span class="small text-muted d-block mt-1">
                                    Destino típico: En revisión (mismo paso). Observado no se agrega a la flecha lineal.
                                </span>
                            }
                        </div>

                        <div [class.col-md-6]="!flow.allowsToken" [class.col-12]="flow.allowsToken">
                            <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                                <label class="mb-0 flex-grow-1 min-w-0" [for]="'req-doc-' + index">
                                    <span class="d-block fw-semibold">Exigir documento al aprobar</span>
                                    <span class="small text-muted">
                                        Solicita al aprobador adjuntar un documento (ej. Acta, Voto, Resolución).
                                    </span>
                                </label>
                                <div class="form-check form-switch m-0 flex-shrink-0">
                                    <input class="form-check-input" type="checkbox" role="switch" [id]="'req-doc-' + index"
                                        [(ngModel)]="flow.requiresDocument"
                                        (ngModelChange)="onRequiresDocumentChange()">
                                </div>
                            </div>
                            @if (flow.requiresDocument) {
                                <label class="form-label mb-0" [for]="'doc-type-' + index">Tipo de Documento</label>
                                <ng-select class="mt-1"
                                    [items]="documentTypes"
                                    bindLabel="name"
                                    bindValue="slug"
                                    placeholder="Seleccionar tipo de documento"
                                    [(ngModel)]="flow.documentTypeSlug"
                                    (ngModelChange)="onDocumentTypeChange($event)"
                                    [clearable]="false"
                                    [labelForId]="'doc-type-' + index"
                                    appendTo="body">
                                </ng-select>
                            }
                        </div>
                        }

                        <div [class.col-md-6]="isTerminalStep() || !flow.allowsToken" [class.col-12]="!isTerminalStep() && flow.allowsToken">
                            <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                                <label class="mb-0 flex-grow-1 min-w-0" [for]="'notify-' + index">
                                    <span class="d-block fw-semibold">{{ isTerminalStep() ? 'Avisar al completar' : 'Notificar al rol' }}</span>
                                    <span class="small text-muted">
                                        @if (isTerminalStep()) {
                                            Correo opcional cuando la solicitud llega a este cierre.
                                        } @else if (flow.requiredRole && tokenCoversRole()) {
                                            El enlace público ya cubre a este rol.
                                        } @else if (flow.requiredRole) {
                                            Correo de bandeja (<code>?uuid=</code>).
                                        } @else {
                                            Requiere un rol asignado.
                                        }
                                    </span>
                                </label>
                                <div class="form-check form-switch mb-0 flex-shrink-0">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                        [id]="'notify-' + index"
                                        [(ngModel)]="flow.notifyRole"
                                        (ngModelChange)="emitChanged()"
                                        [disabled]="!isTerminalStep() && !flow.requiredRole">
                                </div>
                            </div>
                        </div>

                        @if (isTerminalStep() && flow.notifyRole) {
                            <div class="col-md-6">
                                <label class="form-label mb-0" [for]="'notify-role-' + index">Avisar a</label>
                                <select class="form-select mt-1" [id]="'notify-role-' + index"
                                    [(ngModel)]="flow.requiredRole"
                                    (ngModelChange)="emitChanged()">
                                    <option [ngValue]="null">Seleccionar rol</option>
                                    @for (role of availableRoles; track (role.slug || role.name)) {
                                        <option [ngValue]="role.slug || role.name">{{ role.displayName || role.description || role.name }}</option>
                                    }
                                </select>
                            </div>
                        }
                    </div>
                </div>
            </div>

            @if (!isTerminalStep() && flow.allowsToken) {
                <div class="col-lg-6 d-flex flex-column">
                    <div class="border rounded p-3 flex-grow-1">
                        <div class="mb-3">
                            <span class="d-block fw-semibold">Correo de enlace público</span>
                            <span class="small text-muted">Destinatario y estados al confirmar o rechazar.</span>
                        </div>
                        <div class="mb-3">
                            <label class="form-label mb-0" [for]="'audience-' + index">Destinatario</label>
                            <select class="form-select mt-1" [id]="'audience-' + index"
                                [(ngModel)]="flow.tokenAudience"
                                (ngModelChange)="emitChanged()">
                                <option [ngValue]="null" disabled>Seleccionar destinatario</option>
                                <option [ngValue]="'ROLE'">Usuarios del rol del paso</option>
                                <option [ngValue]="'PARTY'">Socio (correo del party)</option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label mb-0" [for]="'confirm-' + index">Al confirmar</label>
                            <select class="form-select mt-1" [id]="'confirm-' + index"
                                [(ngModel)]="flow.tokenConfirmStatusSlug"
                                (ngModelChange)="emitChanged()">
                                <option [ngValue]="null" disabled>Ir a...</option>
                                @for (st of availableStatuses; track st.id) {
                                    <option [ngValue]="st.slug">{{ st.name }}</option>
                                }
                            </select>
                        </div>
                        <div class="mb-0">
                            <label class="form-label mb-0" [for]="'reject-' + index">Al rechazar</label>
                            <select class="form-select mt-1" [id]="'reject-' + index"
                                [(ngModel)]="flow.tokenRejectStatusSlug"
                                (ngModelChange)="emitChanged()">
                                <option [ngValue]="'REJECTED'">Rechazado</option>
                                @for (st of availableStatuses; track st.id) {
                                    @if (st.slug !== 'REJECTED') {
                                        <option [ngValue]="st.slug">{{ st.name }}</option>
                                    }
                                }
                            </select>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
